// extracted by mini-css-extract-plugin
export default {"textContainer":"CommentCell_textContainer__pAPsR","toggleIcon":"CommentCell_toggleIcon__Ph8z4","fadeIn":"CommentCell_fadeIn__5-50Z"};